declare const __GRAFFITI_BUILD__: {product:string;version:string;sourceRevision:string;sourceDirty:boolean};
export const productIdentity = __GRAFFITI_BUILD__;
